import type { Coordinates, Area } from '../components/declarations/PositionInfo.d.ts';

export interface AreaWithId extends Area {
  id: string;
}

export interface ObjectPosition extends AreaWithId {
  hit: Area;
}

export interface ItemPosition extends AreaWithId {
  hit: Area;
  hint: Coordinates;
}

export interface PositionsConfig {
  extra: AreaWithId[];
  objects: ObjectPosition[];
  items: ItemPosition[];
  bg: AreaWithId[];
  name: string;
}

export const positionsConfig: PositionsConfig[] = [
  {
    extra: [],
    items: [
      {
        id: 'veverka_c',
        x: 4559,
        y: 180,
        w: 233,
        h: 165,
        hit: { x: 4550, y: 173, w: 233, h: 212 },
        hint: { x: 4573, y: 194 },
      },
      {
        id: 'veverka_n',
        x: 4559,
        y: 189,
        w: 203,
        h: 163,
        hit: { x: 4550, y: 173, w: 233, h: 212 },
        hint: { x: 4573, y: 194 },
      },
      {
        id: 'had_c',
        x: 2937,
        y: 524,
        w: 284,
        h: 181,
        hit: { x: 2900, y: 489, w: 233, h: 212 },
        hint: { x: 2943, y: 524 },
      },
      {
        id: 'had_n',
        x: 2897,
        y: 539,
        w: 232,
        h: 141,
        hit: { x: 2900, y: 489, w: 233, h: 212 },
        hint: { x: 2943, y: 524 },
      },
    ],
    objects: [{ id: 'object_divocak', x: 1297, y: 571, w: 115, h: 186, hit: { x: 1231, y: 644, w: 233, h: 156 } }],
    bg: [
      { id: 'l6a', x: 0, y: 477, w: 230, h: 323 },
      { id: 'l6b', x: 1119, y: 597, w: 471, h: 203 },
      { id: 'l6c', x: 2647, y: 574, w: 644, h: 226 },
      { id: 'l6d', x: 4458, y: 0, w: 342, h: 454 },
    ],
    name: 'l6',
  },
  {
    extra: [{ id: 'teta', x: 3749, y: 310, w: 305, h: 301 }],
    items: [
      {
        id: 'bobr_c',
        x: 3496,
        y: 554,
        w: 147,
        h: 194,
        hit: { x: 3450, y: 547, w: 233, h: 212 },
        hint: { x: 3506, y: 591 },
      },
      {
        id: 'bobr_n',
        x: 3635,
        y: 494,
        w: 214,
        h: 201,
        hit: { x: 3643, y: 477, w: 202, h: 220 },
        hint: { x: 3683, y: 512 },
      },
      {
        id: 'jelen_c',
        x: 2953,
        y: 175,
        w: 192,
        h: 274,
        hit: { x: 2926, y: 185, w: 254, h: 254 },
        hint: { x: 2992, y: 209 },
      },
      {
        id: 'jelen_n',
        x: 2916,
        y: 174,
        w: 367,
        h: 269,
        hit: { x: 2908, y: 226, w: 343, h: 212 },
        hint: { x: 3002, y: 253 },
      },
      {
        id: 'divocak_c',
        x: 2443,
        y: 195,
        w: 359,
        h: 284,
        hit: { x: 2592, y: 241, w: 233, h: 238 },
        hint: { x: 2667, y: 457 },
      },
      {
        id: 'divocak_n',
        x: 2450,
        y: 236,
        w: 162,
        h: 233,
        hit: { x: 2426, y: 226, w: 197, h: 245 },
        hint: { x: 2458, y: 253 },
      },
      {
        id: 'vlk_c',
        x: 731,
        y: 282,
        w: 208,
        h: 321,
        hit: { x: 718, y: 317, w: 213, h: 288 },
        hint: { x: 891, y: 389 },
      },
      {
        id: 'vlk_n',
        x: 708,
        y: 419,
        w: 223,
        h: 201,
        hit: { x: 718, y: 317, w: 213, h: 288 },
        hint: { x: 891, y: 389 },
      },
      {
        id: 'zaba_c',
        x: 1975,
        y: 74,
        w: 202,
        h: 454,
        hit: { x: 1980, y: 241, w: 201, h: 279 },
        hint: { x: 2148, y: 289 },
      },
      {
        id: 'zaba_n',
        x: 1914,
        y: 24,
        w: 289,
        h: 496,
        hit: { x: 1980, y: 241, w: 201, h: 279 },
        hint: { x: 2148, y: 289 },
      },
      {
        id: 'vyr_c',
        x: 1474,
        y: 28,
        w: 247,
        h: 352,
        hit: { x: 1559, y: 28, w: 185, h: 171 },
        hint: { x: 1725, y: 180 },
      },
      {
        id: 'vyr_n',
        x: 1485,
        y: 137,
        w: 135,
        h: 243,
        hit: { x: 1480, y: 130, w: 185, h: 171 },
        hint: { x: 1649, y: 215 },
      },
    ],
    objects: [
      { id: 'object_veverka', x: 3225, y: 98, w: 70, h: 116, hit: { x: 3195, y: 78, w: 141, h: 129 } },
      { id: 'object_vlk', x: 3419, y: 431, w: 62, h: 91, hit: { x: 3370, y: 394, w: 160, h: 150 } },
      { id: 'object_vyr', x: 4310, y: 605, w: 139, h: 159, hit: { x: 4270, y: 603, w: 189, h: 161 } },
      { id: 'object_had', x: 1528, y: 471, w: 90, h: 151, hit: { x: 1474, y: 449, w: 212, h: 177 } },
      { id: 'object_bobr', x: 2403, y: 591, w: 140, h: 102, hit: { x: 2378, y: 563, w: 202, h: 171 } },
      { id: 'object_medved', x: 4100, y: 493, w: 58, h: 70, hit: { x: 4054, y: 461, w: 157, h: 161 } },
      { id: 'object_zaba', x: 315, y: 6, w: 403, h: 418, hit: { x: 467, y: 169, w: 201, h: 199 } },
    ],
    bg: [
      { id: 'l5a', x: 266, y: 0, w: 1577, h: 800 },
      { id: 'l5b', x: 1804, y: 0, w: 1552, h: 800 },
      { id: 'l5c', x: 3317, y: 0, w: 1217, h: 800 },
    ],
    name: 'l5',
  },
  {
    extra: [],
    items: [
      {
        id: 'medved_c',
        x: 1124,
        y: 293,
        w: 268,
        h: 135,
        hit: { x: 1224, y: 241, w: 233, h: 212 },
        hint: { x: 1258, y: 254 },
      },
      {
        id: 'medved_n',
        x: 1077,
        y: 286,
        w: 281,
        h: 185,
        hit: { x: 1041, y: 235, w: 233, h: 212 },
        hint: { x: 1257, y: 254 },
      },
    ],
    objects: [{ id: 'object_jelen', x: 1142, y: 60, w: 78, h: 113, hit: { x: 1108, y: 42, w: 149, h: 147 } }],
    bg: [
      { id: 'l4a', x: 360, y: 0, w: 1526, h: 800 },
      { id: 'l4b', x: 1842, y: 0, w: 1550, h: 800 },
      { id: 'l4c', x: 3357, y: 0, w: 1083, h: 800 },
    ],
    name: 'l4',
  },
  {
    extra: [],
    objects: [],
    items: [],
    bg: [
      { id: 'l3a', x: 466, y: 0, w: 1948, h: 800 },
      { id: 'l3b', x: 2370, y: 0, w: 1661, h: 800 },
    ],
    name: 'l3',
  },
  { extra: [], objects: [], items: [], bg: [{ id: 'l2', x: 2963, y: 241, w: 1170, h: 559 }], name: 'l2' },
  { extra: [], objects: [], items: [], bg: [{ id: 'l1', x: 2400, y: 213, w: 1267, h: 587 }], name: 'l1' },
  { extra: [], objects: [], items: [], bg: [{ id: 'l0', x: 1464, y: 0, w: 1872, h: 800 }], name: 'l0' },
];
